import {SET_HAV} from '../constants';

export default function auth(state = {}, action) {
    const {type, payload} = action;
    switch (type) {
        case SET_HAV:
            return {hav: payload.hav};
        default:
            return state;
    }
}
